import { Typesense } from "@max/common/src/typesense";
import { useMemo } from "react";

export const useAdditionalArtists = (
  thisArtistGroup: string,
  survey: Pick<Typesense<"surveys">, "additionalGroups" | "artistGroupId">,
) => {
  const additionalGroups = useMemo(() => {
    if (!survey?.additionalGroups || !survey?.additionalGroups?.length) {
      return [];
    }

    // filter self
    return survey.additionalGroups.includes(thisArtistGroup)
      ? // this artist is an additional
        [
          survey.artistGroupId,
          ...survey.additionalGroups.filter((id) => id !== thisArtistGroup),
        ]
      : [...survey.additionalGroups];
  }, [survey, thisArtistGroup]);

  return {
    isAdditional: survey?.additionalGroups?.includes(thisArtistGroup),
    additionalGroups,
  };
};
